import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from "vue";
import FileUploadButton from "primevue/button/Button";
import prettyBytes from "pretty-bytes";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileuploadDropzone',
  props: {
  disabled: {
    type: Boolean,
    default: false
  },
  url: {
    type: String,
    default: null
  },
  withCredentials: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: true
  },
  fileLimit: {
    type: Number,
    default: null
  },
  invalidFileLimitMessage: {
    type: String,
    default: 'Maximum number of files exceeded, limit is {0} at most.'
  },
  auto: {
    type: Boolean,
    default: false
  },
  accept: {
    type: String,
    default: null
  },
  invalidFileTypeMessage: {
    type: String,
    default: '{0}: Invalid file type, allowed file types: {1}.'
  },
  maxFileSize: {
    type: Number,
    default: null
  },
  invalidFileSizeMessage: {
    type: String,
    default: '{0}: Invalid file size, file size should be smaller than {1}.'
  },
  customUpload: {
    type: Boolean,
    default: false
  },
  // mode: {
  //   type: String,
  //   default: 'advanced'
  // },
  name: {
    type: String,
    default: null
  },
},
  emits: [
  'select', 'uploader', 'clear',
  'before-upload', 'progress', 'upload',
  'error', 'before-send', 'upload-start'
],
  setup(__props, { expose, emit: emits }) {

const props = __props;







const fileuploadDraggingOver = ref(false)
const duplicateIEEvent = ref(false)
const messages = ref([])
const files = ref([])
const uploadedFileCount = ref(0)
const focused = ref(false)
const progress = ref(null)
const fileInput = ref(null)

const onDragEnter = (event) => {
  if (!props.disabled) {
    event.stopPropagation();
    event.preventDefault();
  }
}

const chooseClass = computed(() => {
  return {
    'btn-success': !props.disabled,
    'btn-disabled': props.disabled
  }
})

const onDragOver = (event) => {
  if (!props.disabled) {
    fileuploadDraggingOver.value = true;
    // DomHandler.addClass(this.$refs.content, 'p-fileupload-highlight');
    event.stopPropagation();
    event.preventDefault();
  }
}
const onDragLeave = () => {
  if (!props.disabled) {
    fileuploadDraggingOver.value = false;
    //DomHandler.removeClass(this.$refs.content, 'p-fileupload-highlight');
  }
}

const acceptFormatText = computed(() => {
  if (props.accept) {
    return props.accept.split(',').map(mimetype => {
      const r = mimetype.trim().split('/').pop();
      return r.toUpperCase();
    }).filter((s) => !!s).join(', ');
  }
  else {
    return 'any';
  }
})

const clear = () => {
  files.value.splice(0);
  messages.value.splice(0);
  emits('clear');

  if (isAdvanced) {
    clearInputElement();
  }
}

const choose = () => {
  // console.log(fileInput);
  // console.log(fileInput.value);
  fileInput.value.click();
}

const isAdvanced = computed(() => {
  //return props.mode === 'advanced';
  return true;
})

const onDrop = (event) => {
  if (!props.disabled) {
    fileuploadDraggingOver.value = false;
    // DomHandler.removeClass(this.$refs.content, 'p-fileupload-highlight');
    event.stopPropagation();
    event.preventDefault();

    const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    const allowDrop = props.multiple || (files && files.length === 1);

    if (allowDrop) {
      onFileSelect(event);
    }
  }
}

const onFocus = () => {
  focused.value = true;
}

const onBlur = () => {
  focused.value = false;
}

const isIE11 = () => {
  return !!window['MSInputMethodContext'] && !!document['documentMode'];
}

const hasFiles = computed(() => {
  return files.value && files.value.length > 0;
})


const isFileSelected = (file) => {
  if (files.value && files.value.length) {
    for (let sFile of files.value) {
      if ((sFile.name + sFile.type + sFile.size) === (file.name + file.type + file.size))
        return true;
    }
  }

  return false;
}

const onFileSelect = (event) => {
  if (event.type !== 'drop'
    && isIE11() && duplicateIEEvent.value) {
    duplicateIEEvent.value = false;
    return;
  }

  messages.value.splice(0);

  let selectedFiles = event.dataTransfer ? event.dataTransfer.files : event.target.files;
  for (let file of selectedFiles) {
    if (!isFileSelected(file)) {
      if (validate(file)) {
        if (isImage(file)) {
          file.objectURL = window.URL.createObjectURL(file);
        }
        files.value.push(file);
      }
    }
  }

  emits('select', {originalEvent: event, files: files.value})

  if (props.fileLimit) {
    checkFileLimit();
  }

  if (props.auto && hasFiles && !isFileLimitExceeded()) {
    upload();
  }

  if (event.type !== 'drop' && isIE11()) {
    clearIEInput();
  } else {
    clearInputElement();
  }
}

const clearInputElement = () => {
  fileInput.value.value = '';
}

const clearIEInput = () => {
  if (fileInput) {
    duplicateIEEvent.value = true; //IE11 fix to prevent onFileChange trigger again
    fileInput.value.value = '';
  }
}

const isFileLimitExceeded = () => {
  if (props.fileLimit && props.fileLimit <= files.value.length + uploadedFileCount.value && focused.value) {
    focused.value = false;
  }

  return props.fileLimit && props.fileLimit < files.value.length + uploadedFileCount.value;
}

const checkFileLimit = () => {
  if (isFileLimitExceeded()) {
    messages.value.push(props.invalidFileLimitMessage.replace('{0}', props.fileLimit.toString()));
  }
}

const chooseDisabled = computed(() => {
  return props.disabled || (props.fileLimit && props.fileLimit <= files.value.length + uploadedFileCount.value);
})


const isImage = (file) => {
  return /^image\//.test(file.type);
}

const validate = (file) => {
  if (props.accept && !isFileTypeValid(file)) {
    messages.value.push(props.invalidFileTypeMessage.replace('{0}', file.name).replace('{1}', props.accept))
    return false;
  }

  if (props.maxFileSize && file.size > props.maxFileSize) {
    messages.value.push(props.invalidFileSizeMessage.replace('{0}', file.name).replace('{1}', formatSize(props.maxFileSize)));
    return false;
  }

  return true;
}

const upload = () => {
  if (props.customUpload) {
    if (props.fileLimit) {
      uploadedFileCount.value += files.value.length;
    }

    emits('uploader', {files: files.value});
    clear();
  } else {
    emits('upload-start', {files: files.value});

    let xhr = new XMLHttpRequest();
    let formData = new FormData();

    emits('before-upload', {
      'xhr': xhr,
      'formData': formData
    });

    for (let file of files.value) {
      formData.append(props.name, file, file.name);
    }

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        progress.value = Math.round((event.loaded * 100) / event.total);
      }

      emits('progress', {
        originalEvent: event,
        progress: progress.value
      });
    });

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        progress.value = 0;

        if (xhr.status >= 200 && xhr.status < 300) {
          if (props.fileLimit) {
            uploadedFileCount.value += files.value.length;
          }

          emits('upload', {
            xhr: xhr,
            files: files.value
          });
        } else {
          emits('error', {
            xhr: xhr,
            files: files.value
          });
        }

        clear();
      }
    };

    xhr.open('POST', props.url, true);

    emits('before-send', {
      'xhr': xhr,
      'formData': formData
    });

    xhr.withCredentials = props.withCredentials;

    xhr.send(formData);
  }
}

const formatSize = (bytes) => {
  if (bytes === 0) {
    return '0 B';
  }
  let k = 1000,
    dm = 3,
    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const isWildcard = (fileType) => {
  return fileType.indexOf('*') !== -1;
}

const getTypeClass = (fileType) => {
  return fileType.substring(0, fileType.indexOf('/'));
}

const isFileTypeValid = (file) => {
  let acceptableTypes = props.accept.split(',').map(type => type.trim());
  for (let type of acceptableTypes) {
    let acceptable = isWildcard(type) ? getTypeClass(file.type) === getTypeClass(type)
      : file.type == type || getFileExtension(file).toLowerCase() === type.toLowerCase();
    if (acceptable) {
      return true;
    }
  }
  return false;
}

const getFileExtension = (file) => {
  return '.' + file.name.split('.').pop();
}

const dropzoneClass = computed(() => {
  return {
    'c-fileupload-highlight': fileuploadDraggingOver.value,
    'c-fileupload-disabled': props.disabled
  }
})

expose({
  clear,
})


return { __sfc: true,props, emits, fileuploadDraggingOver, duplicateIEEvent, messages, files, uploadedFileCount, focused, progress, fileInput, onDragEnter, chooseClass, onDragOver, onDragLeave, acceptFormatText, clear, choose, isAdvanced, onDrop, onFocus, onBlur, isIE11, hasFiles, isFileSelected, onFileSelect, clearInputElement, clearIEInput, isFileLimitExceeded, checkFileLimit, chooseDisabled, isImage, validate, upload, formatSize, isWildcard, getTypeClass, isFileTypeValid, getFileExtension, dropzoneClass, computed, ref, FileUploadButton, prettyBytes }
}

})